<template>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">{{ title }}</h4>
        <slot name="headerright"></slot>
      </div>
      <div class="modal-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import BaseComponent from './Base.vue';
import { defineComponent } from "vue";

export default defineComponent({
    extends: BaseComponent,
    props: {
        title: { required: true,
            type: String
        }
    }
})


</script>